// Copyright (c) Move Closer 2022.

import { Container, IConfiguration } from '@movecloser/front-core'

import pkg from '../../package.json'
import { Updater, VersionMode } from './updater'

/**
 * Apply all needed update patches.
 *
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export async function applyPatches (container: Container, configuration: IConfiguration): Promise<void> {
  const updater = new Updater(
    pkg.version,
    VersionMode.SemVer,
    container,
    process.env.VUE_APP_VERSION_KEY ?? undefined
  )

  await updater.applyPatches(
    configuration.byFile('patches')
  )
}
